

























































































































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'

settings =
  name: 'RemittanceShow'

  resources:
    item:
      resourceName: 'remittance'
      slug: 'remittances/:remittanceId'

    line_items:
      resourceName: 'remittance_line_item'
      slug: 'remittances/:remittanceId/remittance_line_items'
      params:
        limit: 9999

  vue:
    components: { SuperContainerView, Back }
    props: ['remittanceId']

    computed:
      lineItems: -> @line_items || []

    methods:
      hasEventForLineItem: (lineItem) -> @ctxEvent(lineItem)?.id?
      hasOfferForLineItem: (lineItem) -> @ctxOffer(lineItem)?.id?
      generatingOfferForLineItem: (lineItem) -> @hasEventForLineItem(lineItem) && not @hasOfferForLineItem(lineItem)

export default VueOptions.vue settings
